export default "__VITE_ASSET__d2b8b138__"